/**
 * Created by denis on 26/12/19
 */

cleverapps.Flags = function () {
    cleverapps.EventEmitter.call(this);

    this.init();

    cleverapps.whenAllInitialized(() => {
        cleverapps.paymentsHistory.onAddPaymentListeners.flags = this.update.bind(this);
    });
};

cleverapps.Flags.prototype = Object.create(cleverapps.EventEmitter.prototype);
cleverapps.Flags.prototype.constructor = cleverapps.Flags;

cleverapps.Flags.prototype.init = function () {
    // Google Play's pre-launch robots (Firebase Test Lab) are not players
    this.noLogEvents = connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB) || connector.info.isGoogleTestDevice;
    this.softCurrencyRealProduct = connector.platform.oneOf(connector.MOBAGE, connector.SP_MOBAGE);
    this.fixedChests = connector.platform.oneOf(connector.GDCOM) && connector.info.hybrid;

    this.monetization = cleverapps.Flags.MONETIZATION_REGULAR;
    this._updateMonetization();

    const onUpdateSocial = function () {
        this.nologin = connector.social.oneOf(connector.NONE) || cleverapps.config.nologin;
        this.requestsEnabled = connector.social.getStatus() !== connector.STATUS_DISABLED && connector.social.isSupportsNativeRequest;
    }.bind(this);

    connector.social.on("pluginChanged", onUpdateSocial);
    onUpdateSocial();
};

cleverapps.Flags.prototype.toggle = function (flag) {
    this.set(flag, !this[flag]);
};

cleverapps.Flags.prototype.get = function (flag) {
    return this[flag];
};

cleverapps.Flags.prototype.set = function (flag, value) {
    if (this[flag] === value) {
        return;
    }

    this[flag] = value;

    this.trigger(`change:${flag}`, value);
};

cleverapps.Flags.prototype.reset = function () {
    this.init();
    this.update();
};

cleverapps.Flags.prototype._updateMonetization = function () {
    let monetization = cleverapps.Flags.MONETIZATION_REGULAR;

    if (connector.payments.getStatus() === connector.STATUS_DISABLED) {
        if (connector.ads.getStatus() === connector.STATUS_DISABLED) {
            monetization = cleverapps.Flags.MONETIZATION_DISABLED;
        } else {
            monetization = cleverapps.Flags.MONETIZATION_ADS;
        }
    }

    this.set("monetization", monetization);
};

cleverapps.Flags.prototype.update = function () {
    this._updateMonetization();

    const keepAnnoying = ["merge", "merge2"].includes(cleverapps.config.type) || cleverapps.paymentsHistory.classify() === cleverapps.PaymentsHistory.BRACKET_NONE;

    if (!keepAnnoying) {
        this.requestsEnabled = false;
        levels.friendRequests.deleteFakeRequests();
    }
};

Object.defineProperty(cleverapps.Flags.prototype, "norest", {
    get: function () {
        return Boolean(connector.config.norest);
    },
    set: function (value) {
        connector.config.norest = Boolean(value);
    }
});

// the multiplayer (cups, leagues, clans) is off as under norest, also for a cheater: his scores stay out of the tops
Object.defineProperty(cleverapps.Flags.prototype, "nomulti", {
    get: function () {
        return this.norest || Boolean(cleverapps.user && cleverapps.user.cheater);
    }
});

cleverapps.Flags.MONETIZATION_DISABLED = "disabled";
cleverapps.Flags.MONETIZATION_ADS = "ads";
cleverapps.Flags.MONETIZATION_REGULAR = "regular";